import { Box } from '@mui/material';
import { LinkedLogoAsSvg } from '../../Layouts/Logo/LinkedLogoAsSvg';
export const AuthFormLogo = () => <Box sx={{
  mb: 3
}} data-sentry-element="Box" data-sentry-component="AuthFormLogo" data-sentry-source-file="AuthFormLogo.tsx">
    <LinkedLogoAsSvg height={60} variant="default" data-sentry-element="LinkedLogoAsSvg" data-sentry-source-file="AuthFormLogo.tsx" />
  </Box>;